import { useAction } from "@/hooks/shared";
import { resetPasswordHandler } from "@/services";

export const useResetPassword = () => useAction(resetPasswordHandler);
